<script setup lang="ts">

import { MAX_UPLOAD_SIZE } from '@/documents/composables/documentUpload'
import { prettyPrintSize } from '@/application/utils/prettyPrintSize';
</script>

<template>
  <div class="mt-2.5">
    <small class="text-muted">
      Möglich sind Bilder und pdf-Dateien mit einer Größe von maximal
      {{ prettyPrintSize(MAX_UPLOAD_SIZE) }}
    </small>
  </div>
</template>
